<template>
  <div class="material-store-wrapper">
    <div class="material-content">
      <div
        v-for="(item, index) in local_materials"
        :key="index"
        class="material-item"
        :class="{ 'material-item-video': item.material_type === 2, 'video-vertical': isHorizontalCover(item) }"
      >
        <div v-if="[1, 4].includes(item.material_type)" class="item-border">
          <div class="item-content" style="position: relative">
            <el-image v-for="(pick_image, pick_image_index) in item.url" :key="pick_image ? pick_image.thumb_url : pick_image_index" :style="{width: `calc(100% / ${item.url.length})`}" fit="contain" :src="pick_image ? pick_image.thumb_url : ''" />
            <div class="img-func">
              <el-button
                class="el-button-scale"
                icon="el-icon-zoom-in"
                circle
                @click.stop="openViewer(local_materials, index)"
              />
              <el-button
                class="el-button-replace"
                size="mini"
                type="primary"
                @click="replaceMaterial(item,index)"
              >
                更换素材
              </el-button>
            </div>
          </div>
          <el-tooltip
            effect="dark"
            :content="item.name"
            placement="bottom-start"
          >
            <div class="title">{{ item.name }}</div>
          </el-tooltip>
        </div>
        <div v-else-if="item.material_type === 2" class="item-border">
          <div class="item-content">
            <div class="video-item">
              <video :src="item.url[0].url" controls />
            </div>
            <div class="video-item">
              <el-image fit="contain" :src="item.url[0].thumb_url" />
              <div class="img-func">
                <el-button
                  class="el-button-scale"
                  icon="el-icon-zoom-in"
                  circle
                  @click.stop="openViewer(local_materials, index)"
                />
                <el-button
                  class="el-button-replace"
                  size="mini"
                  type="primary"
                  @click="replaceMaterial(item,index)"
                >
                  更换素材
                </el-button>
              </div>
            </div>
            <div v-if="isHorizontalCover(item)" class="video-item">
              <el-image v-show="item.url[0].horizontal_cover" fit="contain" :src="item.url[0].horizontal_cover" />
              <div v-show="!item.url[0].horizontal_cover" class="empty-wrapper w-full h-full flex-col items-center justify-center">
                <i class="el-icon-picture-outline empty-icon" />
                <div>横版封面选填</div>
              </div>
              <div class="img-func">
                <div v-show="item.url[0].horizontal_cover" class="action-wrapper absolute left-0 top-0 bottom-0 right-0 w-full flex justify-center items-center">
                  <el-button
                    class="el-button-scale zoom-button"
                    icon="el-icon-zoom-in"
                    circle
                    @click.stop="openViewer(local_materials, index, 'horizontal_cover')"
                  />
                  <el-button
                    class="zoom-button"
                    icon="el-icon-delete"
                    circle
                    @click.stop="deleteCover(item, 'horizontal_cover')"
                  />
                </div>
                <el-button
                  class="el-button-replace"
                  size="mini"
                  type="primary"
                  @click="replaceCover(item, index, 'horizontal_cover')"
                >
                  横板封面选填（1140 * 640）
                </el-button>
              </div>
            </div>
          </div>
          <el-tooltip
            effect="dark"
            :content="item.name"
            placement="bottom-start"
          >
            <div class="title">{{ item.name }}</div>
          </el-tooltip>
        </div>
      </div>
    </div>
    <el-image-viewer
      v-if="image_viewer_config.is_show"
      v-bind="image_viewer_config.props"
      :on-close="closeViewer"
    />
    <material-box
      v-if="material_config.is_show"
      :advertiser="channel_interface"
      :is-open="material_config.is_show"
      v-bind="material_config.props"
      @confirm="materialConfirm"
      @cancel="materialCancel"
    />
    <div class="w-full text-center">
      <el-button type="primary" icon="el-icon-position" @click="onConfirmMaterial">确定</el-button>
      <el-button icon="el-icon-close" @click="onCancelMaterial">取消</el-button>
    </div>
  </div>
</template>

<script>
import { clone } from '@/utils';
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';

export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
    'material-box': () => import('@/components/material-box'),
  },
  mixins: [data_sharing_mixin],
  props: {
    // 素材列表
    materialSources: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 渠道信息
    channelData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    /** 是否显示竖版视频横版封面 */
    showHorizontalCover: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      // 本地素材列表
      local_materials: [],
      // 素材库配置
      material_config: {
        index: -1,
        limit: 1,
        is_show: false,
        // 封面类型 - thumb_url：默认封面、horizontal_cover：横板封面、vertical_cover：竖版封面
        cover_type: 'thumb_url',
        props: {
          type: 'image',
          tempMaterial: null,
          gameId: null,
        },
      },
      // 图片预览配置
      image_viewer_config: {
        is_show: false,
        props: {
          initialIndex: 0,
          urlList: [],
          zIndex: 9999,
        },
      },
    };
  },
  computed: {
    // 渠道接口
    channel_interface() {
      const { channel_interface } = this.getInitConfig();
      return channel_interface;
    },
  },
  created() {
    this.local_materials = this.materialSources;
  },
  methods: {
    /**
     * 获取渠道初始化配置
     * @returns {Object} 渠道初始化配置参数
     */
    getInitConfig() {
      try {
        const { getFormContext } = this.local_sharing_data;
        const form_context = getFormContext();
        const { init_ops } = form_context.config;
        return init_ops || {};
      } catch (error){
        console.error(error);
        return {};
      }
    },
    /**
     * 打开预览幻灯片
     * @param {Object[]} list 素材列表 - 图片、视频
     * @param {number} index 素材索引
     * @param {string} cover_type 封面类型 - thumb_url：默认封面、horizontal_cover：横板封面、vertical_cover：竖版封面
     * @returns {void}
     */
    openViewer(list, index, cover_type = 'thumb_url') {
      const urls = list[index].url.map((u) => u[cover_type]);
      Object.assign(this.image_viewer_config.props, { urlList: urls });
      this.image_viewer_config.is_show = true;
    },
    /**
     * 关闭预览幻灯片
     * @returns {void}
     */
    closeViewer() {
      this.image_viewer_config.is_show = false;
    },
    /**
     * 素材库确认
     * @param {Object[]} data 素材库选中的素材
     * @returns {void}
     */
    materialConfirm(data) {
      if (data.length === 0) {
        return;
      }
      const { limit } = this.material_config;
      if (data.length > limit) {
        this.$message.warning(`素材不能超过${limit}个！`);
        this.materialCancel();
        return;
      }
      // 更换封面
      if (this.material_config.props.tempMaterial) {
        const { cover_type } = this.material_config;
        this.local_materials[this.material_config.index].url[0][cover_type] = data[0].url[0].url;
        this.materialCancel();
        return;
      }
      const [res] = data;
      this.local_materials[this.material_config.index] = res;
      this.materialCancel();
    },
    /**
     * 素材库取消选择
     * @returns {void}
     */
    materialCancel() {
      Object.assign(this.material_config.props, { tempMaterial: null });
      Object.assign(this.material_config, { index: -1, cover_type: 'thumb_url' });
      this.material_config.is_show = false;
    },
    /**
     * 替换素材
     * @param {Object} item 要替换的素材
     * @param {number} index 素材的索引位置
     * @returns {void}
     */
    replaceMaterial(item, index) {
      const material_type_map = {
        '1': 'image',
        '2': 'video',
        '4': 'element_story',
      };
      this.material_config.props.type = material_type_map[item.material_type] || material_type_map['1'];
      this.material_config.props.gameId = this.channelData.game_id;
      this.updateMaterialConfigProps();
      this.material_config.is_show = true;
      this.material_config.index = index;
    },
    /**
     * 获取本地素材列表
     * @returns {Promise<Object[]>}
     */
    async getAssignSelection() {
      return Promise.resolve(this.local_materials);
    },
    /**
     * 确定编辑素材
     * @returns {void}
     */
    async onConfirmMaterial() {
      const assigned_res = await this.getAssignSelection();
      this.$emit('confirm', assigned_res);
    },
    /**
     * 取消编辑素材
     * @returns {void}
     */
    async onCancelMaterial() {
      this.$emit('cancel');
    },
    /**
     * 更新素材库配置props
     * @returns {void}
     */
    updateMaterialConfigProps() {
      const { strategy } = this.local_sharing_data.getFormContext();
      const formFields = clone(this.local_sharing_data.getFormFields());
      formFields.material_config.config.material_form.config.material.value.tab = this.material_config.props.type;
      Object.assign(this.material_config.props, { ...strategy.getMaterialProps(formFields.material_config) });
    },
    /**
     * 是否为横板封面
     * @param {Object} material_item 当前素材
     * @returns {Boolean}
     */
    isHorizontalCover(material_item = {}) {
      /**
       * 宽高为以下尺寸时，为竖版视频，即支持横板封面
       * - 720 * 1280
       */
      const valid_sizes = [[720, 1280]];
      const { width, height } = material_item;
      const is_vertical_video = valid_sizes.some(([width_size, height_size]) => width === width_size && height === height_size);
      return this.showHorizontalCover && is_vertical_video;
    },
    /**
     * 更换封面
     * @param {Object} material_item 当前素材
     * @param {number} index 素材的索引位置
     * @param {string} cover_type 封面类型 - thumb_url：默认封面、horizontal_cover：横板封面、vertical_cover：竖版封面
     * @returns {void}
     */
    replaceCover(material_item, index, cover_type = 'thumb_url') {
      const { width, height, size } = this.getMaterialStylePosterInfo(material_item, cover_type);
      const tempMaterial = Object.assign(JSON.parse(JSON.stringify(material_item)), { width, height, size });
      Object.assign(this.material_config.props, { tempMaterial });
      Object.assign(this.material_config, { index, cover_type });
      this.material_config.is_show = true;
    },
    /**
     * 获取素材封面信息
     * @param {Object} material_item 当前素材
     * @param {string} cover_type 封面类型 - thumb_url：默认封面、horizontal_cover：横板封面、vertical_cover：竖版封面
     * @returns {Object}
     */
    getMaterialStylePosterInfo(material_item, cover_type = 'thumb_url') {
      const { width, height, size } = material_item;
      // 默认封面 - 使用素材中的规格
      if (cover_type === 'thumb_url') {
        return { width, height, size };
      }
      const { material_config } = this.local_sharing_data.getFormFields();
      const material = material_config?.config?.material_form?.config?.material || {};
      const { video = {}} = material;

      const target_key = Object.keys(video).find(keys => {
        const video_width = keys.split('#')[0];
        const video_height = keys.split('#')[1];
        return Number(width) === Number(video_width) && Number(height) === Number(video_height);
      }) || '';

      const cover_config = video[target_key] || {};

      return cover_config[cover_type] || {};
    },
    /**
     * 删除封面 - 选填的竖版、横板封面
     * @param {Object} material_item 当前素材
     * @param {string} cover_type 封面类型 - thumb_url：默认封面、horizontal_cover：横板封面、vertical_cover：竖版封面
     * @returns {void}
     */
    deleteCover(material_item, cover_type = 'horizontal_cover') {
      // 此处写法目的是触发响应式更新
      const temp_url = JSON.parse(JSON.stringify(material_item.url));
      temp_url[0][cover_type] = '';
      material_item.url = temp_url;
    },
  },
};
</script>

<style lang="scss">
.material-store-wrapper {
  .material-content {
    height: 344px;
    padding: 10px;
    padding-top: 0;
    overflow: auto;
    .material-item {
      display: inline-block;
      width: 25%;
      height: 50%;
      padding: 10px;
      .item-border {
        position: relative;
        width: 100%;
        height: 100%;
        padding: 10px;
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        display: flex;
        flex-direction: column;
        padding-bottom: 0;
        .item-content {
          flex: 1;
          min-height: 0;
        }
        video,
        .el-image {
          width: 100%;
          height: 100%;
          background-color: #333;
          object-fit: contain;
        }
        .img-func {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          overflow: hidden;
          transition: all 0.3s;
          .el-button.el-button-scale {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            width: 36px;
            height: 36px;
            margin: auto;
            background-color: #3333336e;
            color: #fff;
            &:hover {
              transform: scale(1.2);
            }
          }
          .action-wrapper {
            margin: auto;
            .el-button.el-button-scale.zoom-button {
              position: static;
              margin: 0;
            }
          }
          .el-button-replace {
            position: absolute;
            right: -1px;
            bottom: -29px;
          }
          &:hover {
            .el-button-replace {
              bottom: -1px;
            }
          }
        }
      }
      &.material-item-video {
        width: 50%;
        &.video-vertical {
          width: 100%;
          .item-content {
            display: flex;
            div.video-item {
              padding: 0 5px;
              flex: 1;
            }
          }
        }
        .video-item {
          position: relative;
          float: left;
          width: 50%;
          height: 100%;
          &:nth-child(1) {
            padding-right: 5px;
          }
          &:nth-child(2) {
            padding-left: 5px;
          }
          .empty-wrapper {
            background-color: #f5f7fa;
            .empty-icon {
              font-size: 32px;
            }
          }
        }
      }
    }
  }
  .title {
    line-height: 28px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
